<template>
    <div>
        <crud-update :open="open"
                 :loading="loading || loadingImpact"
                 :title="title"
                 :errorMessage="errorMessage"
                 @update="onUpdateClick"
                 @close="$emit('close')"
    >
         <tamanio-form ref="form" v-model="form" :input-errors="inputErrors" />
    </crud-update>

    <confirm-dialog
        v-model="showConfirmImpact"
        :title="$t('tamanio.modals.updateImpact.title')"
        :description="impactDescription"
        confirm-color="primary"
        max-width="400px"
        @confirmed="executeUpdate"
    />
    </div>
</template>

<script>

    import TamanioProvider from "../../../providers/TamanioProvider";
    
    import {CrudUpdate, ConfirmDialog} from '@dracul/common-frontend'
import ClientError from "@/errors/ClientError";
    
    import TamanioForm from "../TamanioForm";
  
    

    export default {
        name: "TamanioUpdate",
        
        components: { TamanioForm, CrudUpdate, ConfirmDialog },
        
        props:{
          open: {type: Boolean, default: true},
          item: {type: Object, required: true}
        },

        data() {
            return {
                title: 'tamanio.editing',
                errorMessage: '',
                inputErrors: {},
                loading: false,
                loadingImpact: false,
                showConfirmImpact: false,
                pendingImpact: null,
                form: {
                     id: this.item.id,
                    tamanio: this.item.tamanio
                }
            }
        },
        computed: {
            impactDescription() {
                if (!this.pendingImpact) return ''
                const { productosCount, depositosCount } = this.pendingImpact
                const desc = this.$t('tamanio.modals.updateImpact.description', {
                    productosCount,
                    depositosCount
                })
                const question = this.$t('tamanio.modals.updateImpact.confirmQuestion')
                return `${desc} ${question}`
            }
        },
        methods: {
            onUpdateClick() {
                if (!this.$refs.form.validate()) return
                this.loadingImpact = true
                this.errorMessage = ''
                TamanioProvider.getTamanioUpdateImpact(this.form.id)
                    .then(r => {
                        if (r?.data?.tamanioUpdateImpact) {
                            this.pendingImpact = r.data.tamanioUpdateImpact
                            this.showConfirmImpact = true
                        }
                    })
                    .catch(error => {
                        const clientError = new ClientError(error)
                        this.inputErrors = clientError.inputErrors
                        this.errorMessage = clientError.i18nMessage
                    })
                    .finally(() => { this.loadingImpact = false })
            },
            executeUpdate() {
                this.loading = true
                this.errorMessage = ''
                TamanioProvider.updateTamanio(this.form)
                    .then(r => {
                        if (r) {
                            this.$emit('itemUpdated', r.data.tamanioUpdate)
                            this.$emit('close')
                        }
                    })
                    .catch(error => {
                        const clientError = new ClientError(error)
                        this.inputErrors = clientError.inputErrors
                        this.errorMessage = clientError.i18nMessage
                    })
                    .finally(() => {
                        this.loading = false
                        this.pendingImpact = null
                    })
            }
        },
    }
</script>

<style scoped>

</style>

